export const load = () => ({
	title: 'Glossary of Window Insert Terms',
	showTitle: true,
});
